export default __webpack_public_path__ + "static/mobile_sek2_KV10-b1be2e6e1b81f2e104568e1274c464f6.mp4";